import { onTableAjaxFail } from "@sourcewhale/shared/src/assets/js/src/general/elements/tables.js";
import {
  addSearchToggleClickEvent,
  getEndDate,
  getStartDate,
  urlParams,
  uuidV4,
  wrappedGet,
} from "@sourcewhale/shared/src/assets/js/src/general/utils";
import {
  getDateRangePickerChanged,
  setDateRangePickerChanged,
} from "@sourcewhale/shared/src/assets/js/src/state.js";
import { handleLeftClick } from "../contact-panel.js";
import { createCandidateTable } from "../contact-utils.js";

const selectPickerMap = {
  campaignSelector: "campaigns",
  projectSelector: "projectIds",
  stageSelector: "stages",
  sourcerSelector: "sourcerUserIds",
  filterByTag: "tagIds",
  filterByStatus: "status",
};

let activeFilters;

const icon = (text, id = "") => `
  <span class="search-tag badge badge-secondary d-inline-flex align-items-center user-select-none p-1 mr-1 mb-1" id="${id}">
    <span class="name">${text}</span>
    <i style="padding:2px;cursor:pointer;" class="fas fa-times ml-2" id="${id}-remove"></i>
  </span>`;

const addIcon = (key, text) => {
  const existing = $(`#${key}Div .name`)
    .toArray()
    .map((el) => $(el).text());
  const newText = text.trim().toLowerCase();

  if (newText && !existing.includes(newText)) {
    const id = uuidV4();
    $(`#${key}Div`).append(icon(newText, id));
    $(`#${id}-remove`).click(() => {
      $(`#${id}`).remove();
      $("#candidatesTable").DataTable().draw();
    });
  }
  $(`#${key}Input`).typeahead("val", "");
};

export const initializeContacts = () => {
  if (urlParams.get("candidateId")) {
    wrappedGet({
      url: "/api/candidates/get",
      data: { candidateId: urlParams.get("candidateId"), source: "contacts" },
      success: (c) => {
        handleLeftClick("", "", "", c);
      },
    });
  }

  wrappedGet({
    url: "/api/campaigns/get_open",
    success: (res) => {
      createCandidateTable({
        ajax: {
          url: "/api/candidates/query",
          contentType: "application/json",
          type: "POST",
          data: (data) => {
            ["createdAt", "lastContacted", "lastActivity"].forEach((x) => {
              if (!$(`#${x}Toggle`).is(":checked")) {
                data[`${x}From`] = null;
                data[`${x}To`] = null;
                return;
              }

              data[`${x}From`] = moment(
                new Date(getStartDate(`#${x} input`)).setHours(0, 0, 0),
              ).format("YYYY-MM-DD HH:mm:ss");
              data[`${x}To`] = moment(
                new Date(getEndDate(`#${x} input`)).setHours(23, 59, 59),
              ).format("YYYY-MM-DD HH:mm:ss");
            });

            Object.entries(selectPickerMap).forEach(([key, val]) => {
              if ($(`#${key}`).length) {
                data[val] =
                  key === "sourcerSelector"
                    ? $(`#${key}`).selectpicker("val").join()
                    : $(`#${key}`).selectpicker("val");
              }
            });

            data.tagsToggle = $("#tagsToggle").selectpicker("val");
            data.hasPhone = $("#hasPhoneToggle").is(":checked");
            data.hasEmail = $("#hasEmailToggle").is(":checked");
            data.excludeBounced = $("#excludeBouncedToggle").is(":checked");

            ["roles", "companies", "locations"].forEach((key) => {
              data[key] = $(`#${key}Div .name`)
                .toArray()
                .map((el) => $(el).text());
            });

            activeFilters = 0;

            [
              "campaigns",
              "companies",
              "locations",
              "roles",
              "stages",
              "tagIds",
              "projectIds",
            ].forEach((key) => {
              if (data[key] && data[key].length > 0) activeFilters += 1;
            });
            const campaignType = {
              candidateSourcing: [],
              businessDevelopment: [],
            };
            res.forEach((x) => {
              if (campaignType[x.campaignType])
                campaignType[x.campaignType].push(x.campaignId);
            });
            const selectedValue = $("select#filterByCampaignType").val();
            const campaignTypeIds = campaignType[selectedValue] || [];
            if (selectedValue === "_all") data.campaignIds = data.campaigns;
            else {
              const matched = campaignTypeIds.filter((id) =>
                (data.campaigns || []).includes(id),
              );
              if (campaignTypeIds.length === 0 && matched.length === 0)
                data.campaignIds = ["noMatch"];
              else if (matched.length > 0) data.campaignIds = matched;
              else data.campaignIds = campaignTypeIds;
              if (campaignTypeIds.length > 0 && data.campaigns.length === 0)
                data.campaignIds = campaignTypeIds;
            }

            if (data.campaigns && data.campaigns.includes("none")) {
              $("#filterByCampaignType").val("_all").selectpicker("refresh");
              $(".campaign-type-selector .dropdown").addClass("disabled");
              data.campaignIds = data.campaigns;
            } else
              $(".campaign-type-selector .dropdown").removeClass("disabled");

            [
              "hasEmail",
              "hasPhone",
              "excludeBounced",
              "sourcerUserIds",
              "status",
            ].forEach((key) => {
              if (data[key]) activeFilters += 1;
            });

            if (
              $("#lastContactedToggle").is(":checked") ||
              $("#lastActivityToggle").is(":checked") ||
              $("#createdAtToggle").is(":checked")
            )
              activeFilters += 1;

            if (getDateRangePickerChanged()) activeFilters += 1;
            setDateRangePickerChanged(false);

            $("#resetFiltersBtn").toggle(activeFilters > 0);

            return JSON.stringify(data);
          },
          error: onTableAjaxFail("/api/candidates/query"),
        },
        campaignData: res,
        deleteContactBtn: true,
        topContainer: true,
        aiSearchContainer: true,
      });
    },
  });

  $(document).on("change", "select#filterByCampaignType", () =>
    $("#candidatesTable").DataTable().draw(),
  );

  $(document).on(
    "change",
    "select#filterByTag, select#tagsToggle, #lastContactedToggle, #lastActivityToggle, #createdAtToggle, #hasPhoneToggle, #hasEmailToggle, #excludeBouncedToggle, .datepicker, #resetFiltersBtn",
    () => {
      $("#candidatesTable").DataTable().draw();
    },
  );

  addSearchToggleClickEvent({ drawTable: "candidatesTable" });

  ["roles", "companies", "locations"].forEach((key) => {
    $(`#${key}Input`).typeahead({ minLength: 2, autoselect: true });

    $(`#${key}Input`).keydown((e) => {
      if (e.key !== "Enter") return;
      addIcon(key, $(`#${key}Input`).typeahead("val"));
      $("#candidatesTable").DataTable().draw();
    });
  });

  $("#resetFiltersBtn").click(() => {
    $(".boolean-search-toggle").html(`
        <div class="option" data-value="OR">OR</div>
        <div class="option" data-value="AND" style="display: none">AND</div>
        <div class="option" data-value="NOT" style="display: none">NOT</div>
      `);

    ["PhoneToggle", "EmailToggle"].forEach((key) => {
      $(`#has${key}`).prop("checked", false);
    });

    $("#excludeBouncedToggle").prop("checked", false);

    ["roles", "companies", "locations"].forEach((key) => {
      $(`#${key}Div`).empty();
    });

    Object.entries(selectPickerMap).forEach(([key]) =>
      $(`#${key}`).val("").selectpicker("refresh"),
    );

    $("#filterByCampaignType").val("_all").selectpicker("refresh");

    ["lastContactedToggle", "lastActivityToggle", "createdAtToggle"].forEach(
      (key) => {
        $(`#${key}`).prop("checked", false).trigger("change");
      },
    );

    ["createdAt", "lastContacted", "lastActivity"].forEach((key) => {
      $(`#${key} input`)
        .data("daterangepicker")
        .setStartDate(new Date("01/01/2020"));
      $(`#${key} input`).data("daterangepicker").setEndDate(moment());
    });

    $("#candidatesTable").DataTable().draw();
    $("#resetFiltersBtn").hide();
  });

  ["lastContacted", "lastActivity", "createdAt"].forEach((key) => {
    $(`#${key}Toggle`).change(() => {
      $(`#${key}`).toggle($(`#${key}Toggle`).is(":checked"));
    });
  });

  $("#candidatesTable_info").appendTo("#copyTableInfo");
};
